import { ContactPhoneNumberModel, ContactAddressModel, AccountModel, ImpersonatorModel, FansModel } from './index';

export abstract class BaseProfileModel {
  companyId: string;
  contactPhoneNumber?: ContactPhoneNumberModel;
  userId?: string;
  firstName?: string;
  lastName?: string;
  emailAddress?: string;
  fanList?: Array<string>;
  roles?: string;
  permission?: string;
  impersonator?: ImpersonatorModel;
  clientIPAddress?: string;
  fans?: Array<FansModel>;
  addpAuthority?: string;
  fanSignedUpStatus?: string;
  agreement?: any;

  constructor(profile) {
  }
}